import { COLOR } from '@farewill/ui/tokens'

export const ACTIVE_NAVIGATION_LINK_STYLES = {
  borderBottomColor: COLOR.ACCENT.SECONDARY,
}
